let predictiveSearchPromise;

function loadPredictiveSearch() {
  if (!predictiveSearchPromise) {
    predictiveSearchPromise = import(new URL('predictive-search-core.js', import.meta.url).href);
  }

  return predictiveSearchPromise;
}

function openSearchModal() {
  const searchModal = document.getElementById('search-modal');
  if (typeof searchModal?.showDialog === 'function') searchModal.showDialog();
}

function setupPredictiveSearchPreload() {
  const searchTriggers = document.querySelectorAll('search-button, button[aria-haspopup="dialog"]');

  for (const trigger of searchTriggers) {
    trigger.addEventListener('pointerenter', loadPredictiveSearch, { once: true, passive: true });
    trigger.addEventListener('pointerdown', loadPredictiveSearch, { once: true, passive: true });
    trigger.addEventListener('focusin', loadPredictiveSearch, { once: true });
  }

  document.getElementById('search-modal')?.addEventListener('dialog:open', loadPredictiveSearch, { once: true });

  const warmPredictiveSearch = () => {
    loadPredictiveSearch().catch(() => {});
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(warmPredictiveSearch, { timeout: 2500 });
  } else {
    window.setTimeout(warmPredictiveSearch, 1500);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupPredictiveSearchPreload, { once: true });
} else {
  setupPredictiveSearchPreload();
}

document.addEventListener('keydown', (event) => {
  if (!(event.metaKey || event.ctrlKey) || event.key.toLowerCase() !== 'k') return;

  event.preventDefault();
  loadPredictiveSearch().then(() => customElements.whenDefined('dialog-component')).then(openSearchModal);
});
